import { ratingOf } from "@audit-plan/shared";
import { useTranslation } from "react-i18next";
import { palette } from "../../theme";
import { fmtN } from "../pills";

export function ScoreRing({ value, override }: { value: number | null | undefined; override?: string | null }) {
  const { t } = useTranslation();
  const r = 48;
  const c = 2 * Math.PI * r;
  const p = value == null ? 0 : value / 100;
  const color = value == null ? palette.hair : override === "D" ? palette.bad : value >= 70 ? palette.ok : value >= 55 ? palette.warn : palette.bad;
  return (
    <svg viewBox="0 0 116 116" width={116} height={116} role="img" aria-label={t("scoreTotal")}>
      <circle cx={58} cy={58} r={r} fill="none" stroke={palette.hair} strokeWidth={10} />
      <circle cx={58} cy={58} r={r} fill="none" stroke={color} strokeWidth={10} strokeDasharray={`${c * p} ${c}`} strokeLinecap="round" transform="rotate(-90 58 58)" />
      <text x={58} y={58} textAnchor="middle" style={{ fontSize: 24, fontWeight: 800, fill: palette.heading }}>
        {value == null ? "—" : fmtN(value, 1)}
      </text>
      <text x={58} y={78} textAnchor="middle" style={{ fontSize: 11, fontWeight: 700, fill: palette.muted }}>
        {value == null ? "" : `Rating ${ratingOf(value, override)}`}
      </text>
    </svg>
  );
}
